var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "drink-card-order-container" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleTabChange },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "全部", name: "all" } }),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "未支付", name: "0" } }),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "已支付", name: "1" } }),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "已取消", name: "2" } }),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "已退款", name: "4" } }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          staticStyle: { "margin-bottom": "10px" },
          attrs: { inline: true, model: _vm.searchForm, size: "small" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "订单号" } },
            [
              _c("el-input", {
                staticStyle: { width: "220px" },
                attrs: { placeholder: "订单号", clearable: "" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleFilter($event)
                  },
                },
                model: {
                  value: _vm.searchForm.orderSn,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "orderSn", $$v)
                  },
                  expression: "searchForm.orderSn",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: { click: _vm.handleFilter },
                },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-refresh" },
                  on: { click: _vm.resetSearch },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "", size: "small" },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "90" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "会员名称", "min-width": "170" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("div", [
                      _vm._v(
                        _vm._s(row.userId) +
                          " / " +
                          _vm._s(row.userMobile || "-")
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { color: "#909399" } }, [
                      _vm._v(
                        _vm._s(row.userAlias || "-") +
                          " / LV" +
                          _vm._s(row.userRank || 0)
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "类型", width: "80", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function () {
                  return [_vm._v("畅饮卡")]
                },
                proxy: true,
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "流水号/POS端", "min-width": "170" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("div", [_vm._v(_vm._s(row.orderSn))]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { color: "#909399" } }, [
                      _vm._v(_vm._s(row.posOrderSn || "-")),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "订单金额", width: "100", align: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [_vm._v(_vm._s(Number(row.totalAmount).toFixed(2)))]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "购买内容", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.drinkCardImg
                      ? _c("el-image", {
                          staticStyle: {
                            width: "56px",
                            height: "40px",
                            "border-radius": "4px",
                          },
                          attrs: {
                            src: _vm.resPath + row.drinkCardImg,
                            "preview-src-list": [
                              _vm.resPath + row.drinkCardImg,
                            ],
                            fit: "cover",
                          },
                        })
                      : _c("span", { staticStyle: { color: "#ccc" } }, [
                          _vm._v("-"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "门店", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [_vm._v(_vm._s(row.shopName || "-"))]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "平台", width: "70", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function () {
                  return [_vm._v("点餐")]
                },
                proxy: true,
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "支付", width: "90", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [_vm._v(_vm._s(row.payType || "-"))]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "状态", width: "90", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        style: {
                          color: row.payStatus === 1 ? "#67C23A" : "#909399",
                        },
                      },
                      [_vm._v(_vm._s(_vm.payStatusText(row.payStatus)))]
                    ),
                    _vm._v(" "),
                    row.payStatus === 1
                      ? _c("div", { staticStyle: { color: "#909399" } }, [
                          _vm._v("已发放"),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "发票", width: "90", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.redPdfUrl
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { color: "red" },
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDownloadInvoice(row)
                              },
                            },
                          },
                          [_vm._v("已冲红")]
                        )
                      : row.pdfUrl
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDownloadInvoice(row)
                              },
                            },
                          },
                          [_vm._v("已开票")]
                        )
                      : _c("span", [
                          _vm._v(
                            _vm._s(_vm.invoiceStatusText(row.invoiceStatus))
                          ),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "下单时间/支付时间", width: "170" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.parseTime(
                            row.createTime,
                            "{y}-{m}-{d} {h}:{i}:{s}"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { color: "#909399" } }, [
                      _vm._v(
                        _vm._s(
                          row.payTime
                            ? _vm.parseTime(
                                row.payTime,
                                "{y}-{m}-{d} {h}:{i}:{s}"
                              )
                            : "-"
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "300",
              align: "center",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      { staticClass: "op-btns" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "success", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleViewCoupons(row)
                              },
                            },
                          },
                          [_vm._v("券明细")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleCouponLog(row)
                              },
                            },
                          },
                          [_vm._v("发券记录")]
                        ),
                        _vm._v(" "),
                        row.payStatus === 1
                          ? _c(
                              "el-button",
                              {
                                staticClass: "refund-btn",
                                attrs: {
                                  type: "danger",
                                  size: "mini",
                                  loading: _vm.isRefundingRow(row),
                                  disabled: _vm.refundLoading,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleRefund(row)
                                  },
                                },
                              },
                              [_vm._v("申请退款")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              "current-page": _vm.searchForm.page,
              "page-sizes": [10, 20, 30, 50],
              "page-size": _vm.searchForm.limit,
              total: _vm.total,
            },
            on: {
              "current-change": _vm.handlePageChange,
              "size-change": _vm.handleSizeChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "本单券明细",
            visible: _vm.couponListVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.couponListVisible = $event
            },
          },
        },
        [
          _vm.couponListLoading
            ? _c(
                "div",
                { staticStyle: { "text-align": "center", padding: "30px" } },
                [
                  _c("i", {
                    staticClass: "el-icon-loading",
                    staticStyle: { "font-size": "24px" },
                  }),
                ]
              )
            : _c(
                "div",
                [
                  _vm._l(_vm.drinkCardItems, function (pkg, pi) {
                    return _c(
                      "div",
                      { key: pi },
                      _vm._l(pkg.coupons, function (coupon, ci) {
                        return _c(
                          "div",
                          {
                            key: ci,
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              padding: "12px 0",
                              "border-bottom": "1px solid #f0f0f0",
                            },
                          },
                          [
                            coupon.couponImgUrl
                              ? _c("el-image", {
                                  staticStyle: {
                                    width: "64px",
                                    height: "44px",
                                    "border-radius": "4px",
                                    "margin-right": "12px",
                                    "flex-shrink": "0",
                                  },
                                  attrs: {
                                    src: _vm.resPath + coupon.couponImgUrl,
                                    fit: "cover",
                                  },
                                })
                              : _c("div", {
                                  staticStyle: {
                                    width: "64px",
                                    height: "44px",
                                    background: "#f5f5f5",
                                    "border-radius": "4px",
                                    "margin-right": "12px",
                                    "flex-shrink": "0",
                                  },
                                }),
                            _vm._v(" "),
                            _c("div", { staticStyle: { flex: "1" } }, [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "14px",
                                    "font-weight": "500",
                                  },
                                },
                                [_vm._v(_vm._s(coupon.couponAlias))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    color: "#909399",
                                    "margin-top": "4px",
                                  },
                                },
                                [_vm._v("数量：×" + _vm._s(coupon.sendNum))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    color: "#606266",
                                    "margin-top": "2px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                发放ID：" +
                                      _vm._s(
                                        _vm.grantIdsOf(coupon).length
                                          ? _vm.grantIdsOf(coupon).join("、")
                                          : "-"
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-tag",
                              {
                                staticStyle: { "flex-shrink": "0" },
                                attrs: {
                                  type:
                                    pkg.logStatus === 1
                                      ? "success"
                                      : pkg.logStatus === 2
                                      ? "warning"
                                      : "danger",
                                  size: "mini",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      pkg.logStatus === 1
                                        ? "已发券"
                                        : pkg.logStatus === 2
                                        ? "处理中"
                                        : "发券失败"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    )
                  }),
                  _vm._v(" "),
                  _vm.drinkCardItems.length === 0
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "center",
                            color: "#909399",
                            padding: "20px",
                          },
                        },
                        [_vm._v("暂无数据")]
                      )
                    : _vm._e(),
                ],
                2
              ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "券包发放记录",
            visible: _vm.couponLogVisible,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.couponLogVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.couponLogList, border: "", size: "small" } },
            [
              _c("el-table-column", {
                attrs: { label: "券包编码", prop: "packageCode", width: "140" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "CRM会员ID", prop: "memberId", width: "110" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "状态", width: "70", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                row.status === 1
                                  ? "success"
                                  : row.status === 2
                                  ? "warning"
                                  : "danger",
                              size: "mini",
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  row.status === 1
                                    ? "成功"
                                    : row.status === 2
                                    ? "处理中"
                                    : "失败"
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "推送信息",
                  prop: "requestData",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "错误信息",
                  prop: "errorMsg",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "响应内容",
                  prop: "responseData",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "时间", width: "155" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(
                            row.createTime
                              ? _vm.parseTime(
                                  row.createTime,
                                  "{y}-{m}-{d} {h}:{i}:{s}"
                                )
                              : "-"
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "80", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.status === 0 || row.status === 2
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "warning", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleRetry(row)
                                  },
                                },
                              },
                              [_vm._v("重推")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.couponLogList.length === 0
            ? _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "center",
                    color: "#909399",
                    padding: "20px",
                  },
                },
                [_vm._v("暂无记录")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }